<!--

  @copyright Copyright (c) Open-Xchange GmbH, Germany <info@open-xchange.com>
  @license AGPL-3.0

  This code is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with OX App Suite. If not, see <https://www.gnu.org/licenses/agpl-3.0.txt>.

  Any use of the work other than as authorized under this license or copyright law is prohibited.

-->

<template>
  <li
    class="category-browser-calendar-item flex"
    aria-hidden="true"
    data-detail-popup="appointment"
    :data-cid="data.cid"
  >
    <div class="icon-container grow-0 shrink-0">
      <div
        class="color-indicator rounded h-full"
        :title="indicatorTitle"
        :style="indicatorStyle"
      ></div>
    </div>
    <div class="info-container">
      <div class="flex-row h-16 items-center justify-between" v-html="dateTime()"></div>
      <div class="flex-row h-16 items-center justify-between">
        <div class="summary ellipsis font-bold" :title="data.summary">{{ data.summary }}</div>
      </div>
      <BadgeList :limit="3" :collection="data.categories"/>
    </div>
  </li>
</template>

<script setup>
import { getDateTimeIntervalMarkup, deriveAppointmentColors, getAppointmentColor } from '@/io.ox/calendar/util'
import BadgeList from '@/io.ox/core/categories/browser/badge-list.vue'
import { ref, onMounted } from 'vue'
import folderAPI from '@/io.ox/core/folder/api'
import { DateTime } from 'luxon'

const { data } = defineProps(['data'])
const indicatorTitle = ref('')
const indicatorStyle = ref({})
onMounted(() => {
  folderAPI.get(data.folder).then(folder => {
    const color = getAppointmentColor(folder, data)
    const itemColors = deriveAppointmentColors(color)
    indicatorStyle.value = { 'background-color': itemColors.border || itemColors.background }
    indicatorTitle.value = folder.display_title
  })
})

function dateTime () {
  return getDateTimeIntervalMarkup(
    { startDate: data.startDate, endDate: data.endDate },
    { zone: DateTime.local().zoneNAME, noTimezoneLabel: true }
  ).html()
}
</script>

<style lang="scss">
.category-browser-calendar-item {
  cursor: pointer;
  padding: 8px 16px 8px 0;
  height: 72px;
  .icon-container {
    padding-left: 10px;
    width: 32px;
    .color-indicator { width: 8px; }
  }
  .info-container { width: calc(100% - 32px); }
  .categories-badges .category-view {
    margin-top: 4px;
    line-height: 18px;
    height: 18px;
    border-radius: 6px;
    padding-inline: 4px;
  }
}
</style>
